import { Base } from "../../../../base/components/base"
import { TabTitle } from "./tab-title"
import { tabTitlesStyle } from "./tab-titles.style"

export const TabTitles = () => {

    const base = Base()
    base.cssClass(tabTitlesStyle)

    const tocad = TabTitle('tocad', 'کریپتو')
    const cad = TabTitle('cad', 'دلار کانادا')
    const usd = TabTitle('usd', 'دلار آمریکا')
    const cash = TabTitle('cash', 'نقد')
    const banners = TabTitle('banners', 'بنرها')
    const articles = TabTitle('articles', 'مقالات')
    const analytics = TabTitle('analytics', 'آمار')
    const faqs = TabTitle('faqs', 'سوالات متداول')

    const items = [tocad, cad, usd, cash, banners, articles, analytics, faqs]
    items.forEach(item => {
        item.on('select', (id: string) => {
            items.forEach(i => {
                if (i.id === id) {
                    i.select()
                } else {
                    i.unselect()
                }
            })
            base.emit('select', id)
        })
    })

    tocad.select()

    base.append(...items)

    return base
}